var exports = {
  "xE": "WarningAlert.module__alert___OFhrOF",
  "Kk": "WarningAlert.module__icon___OFhrOF",
  "Qs": "WarningAlert.module__content___OFhrOF",
  "DD": "WarningAlert.module__title___OFhrOF",
  "Qq": "WarningAlert.module__text___OFhrOF",
  "nf": "WarningAlert.module__link___OFhrOF",
  "o1": "WarningAlert.module__actions___OFhrOF",
};

module.exports = exports;
